import {styled} from "@mui/material/styles"
import {Grid} from "@mui/material"
import {breakpoints} from "@next/themes"

export const StyledProductGridWrapper = styled(Grid, {
    shouldForwardProp: prop =>
        prop !== "largertoppaddingdesktop" &&
        prop !== "isSearchBannerEnabled" &&
        prop !== "isAutocorrected" &&
        prop !== "urlIsSaleOrClearance",
})<{
    largertoppaddingdesktop?: boolean
    isSearchBannerEnabled?: boolean
    isAutocorrected: boolean
    urlIsSaleOrClearance: boolean
}>`
    position: relative;
    flex: 1 0 80%;
    align-content: flex-start;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    ${({isAutocorrected}) => isAutocorrected && `padding-top: 1rem;`}
    @media (min-width: ${breakpoints.values.md}px) {
        padding: ${({urlIsSaleOrClearance}) => (urlIsSaleOrClearance ? `0 1.5rem` : "0 0.5rem")};
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        flex: 1 0 75%;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        flex: 1 0 80%;
    }
`

export default StyledProductGridWrapper
